export default __webpack_public_path__ + "static/media/feather-globe.a3ebc8de.svg";